import Builder from '@app/store/builder.ts';
var STATE = Builder.state({
    items: window.NAVIGATION,
    isOpen: false,
}, 'Navigation');
var MUTATIONS = {
    setOpenState: function (open) {
        if (open) {
            document.body.classList.add('js-active');
        }
        else {
            document.body.classList.remove('js-active');
        }
        STATE.isOpen = open;
    },
    setItems: function (items) {
        STATE.items = items;
    },
};
var ACTIONS = {
    open: function () {
        MUTATIONS.setOpenState(true);
    },
    close: function () {
        MUTATIONS.setOpenState(false);
    },
    toggle: function () {
        MUTATIONS.setOpenState(!STATE.isOpen);
    }
};
export default {
    STATE: STATE,
    MUTATIONS: MUTATIONS,
    ACTIONS: ACTIONS
};
